"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckSetSelect = exports.CheckSetSelectItem = void 0;
var react_1 = __importDefault(require("react"));
var NoWrapperControl_1 = require("./components/NoWrapperControl");
var NoPanel_1 = require("./components/NoPanel");
var Select_1 = require("./Select");
var SelectUtils_1 = require("./SelectUtils");
var NoContentControl_1 = require("./components/NoContentControl");
var CheckSetSelectItem = function (props) {
    var option = props.option, isSelected = props.isSelected;
    var toRender = SelectUtils_1.formatOption(option);
    return (react_1.default.createElement("label", { className: "c-label +check" + (props.isSelected ? " +is-checked" : "") },
        react_1.default.createElement("input", { className: "c-input", type: "checkbox", checked: isSelected, onChange: function () { return props.onSelect(); } }),
        toRender));
};
exports.CheckSetSelectItem = CheckSetSelectItem;
var CheckSetSelect = function (props) {
    return (react_1.default.createElement(Select_1.Select, __assign({}, props, { multiple: true, searchable: false, components: {
            Option: exports.CheckSetSelectItem,
            OptionContainer: react_1.default.Fragment,
            CollapsedControlContainer: NoWrapperControl_1.NoWrapperControl,
            OptionsPanel: NoPanel_1.NoPanel,
            ValueContainer: NoContentControl_1.NoContentControl,
            DropDownContainer: NoWrapperControl_1.NoWrapperControl,
        } })));
};
exports.CheckSetSelect = CheckSetSelect;
//# sourceMappingURL=CheckSetSelect.js.map